import { toggleDataLayer } from '../services/toggleDataLayer';
const dataLayerToggleVerification = (dimension) => !!toggleDataLayer.get(dimension);
export default dataLayerToggleVerification;
//# sourceMappingURL=dataLayerToggleVerification.js.map